export const stepperPreset = {
  stepper: {
    step: {
      padding: '0',
    },
    stepHeader: {
      gap: '0',
    },
    separator: {
      margin: '0',
      size: '2px',
      background: '#cbd5e1',
      activeBackground: '#0ea5e9',
    },

    stepTitle: {
      activeColor: '#000000',
    },

    stepNumber: {
      size: '1.4rem',
      fontSize: '0.8rem',
      background: '#ffffff',
      borderColor: '#cbd5e1',
      color: '#64748b',
      activeBackground: '#e0f2fe',
      activeBorderColor: '#0ea5e9',
      activeColor: '#0ea5e9',
    },
    css: () => `
        .p-step {
          align-items: center;
          position: relative;
          gap: 0;
        }

        .p-step-header {
          flex-direction: column;
          align-items: center;
          position: relative;
          min-width: auto;
          font-size: 0.8rem;
        }

        .p-step-title {
          position: absolute;
          top: 100%;
          margin-top: 0.25rem;
          white-space: nowrap;
          text-align: center;
          max-width: 10rem;
        }

        .p-stepper-separator {
          flex: 1 1 auto;
          align-self: center;
          margin: 0;
        }  

        .p-steplist{
          overflow-x: visible;
        }

        .p-step-active .p-step-number {
          box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.35);
          border: 1px solid #0ea5e9;
        }
      `,
  },
};
